export const QueryBuilderExcludedUrlsLoading = [
  'query-builder/campaigns/update-status',
  'query-builder/mdm/dimensions',
  'query-builder/mdm/catalog-by-field',
  'query-builder/mdm/count'
];